import { Component, OnInit, Input, inject } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { MatIconRegistry } from '@angular/material/icon'

@Component({
    selector: 'app-external-link',
    templateUrl: './external-link.component.html',
    styleUrls: ['./external-link.component.scss'],
    standalone: false
})
export class ExternalLinkComponent implements OnInit {
    private iconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    @Input() href: string

    ngOnInit() {
        this.iconRegistry.addSvgIcon('external-link', this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/external-link.svg'))
    }
}
